import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import '@/styles/index.scss'

import App from './App.vue'
import router from './router'
import store from './store'
import { hasAllPermissions, hasOperationPermission } from '@/utils/permission'

import '@/permission'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

// 驿站管理员只读 + 操作权限
Vue.mixin({
  computed: {
    readOnly() {
      return this.$store.getters.isStationAdmin
    },
    canExport() {
      const perms = this.$store.getters.permissions
      return hasAllPermissions(perms) || hasOperationPermission(perms, 'op:export')
    },
    canDelete() {
      const perms = this.$store.getters.permissions
      return hasAllPermissions(perms) || hasOperationPermission(perms, 'op:delete')
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
